import { render, staticRenderFns } from "./ClassroomCard.vue?vue&type=template&id=2fd5d58e&scoped=true&"
import script from "./ClassroomCard.vue?vue&type=script&lang=js&"
export * from "./ClassroomCard.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomCard.vue?vue&type=style&index=0&id=2fd5d58e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd5d58e",
  null
  
)

export default component.exports